export const SuccessMessages = {
    CREATED: (fieldName) => `${fieldName} created successfully`,
    UPDATED: (fieldName) => `${fieldName} updated successfully`,
    DELETED: (fieldName) => `${fieldName} deleted successfully`
}

export const ErrorMessages = {
    CREATE_ERROR: (fieldName) => `Failed to create ${fieldName}`,
    UPDATE_ERROR: (fieldName) => `Failed to update ${fieldName}`,
    DELETED_ERROR: (fieldName) => `Failed to deleted ${fieldName}`,
}

